import { FatoVisitaDomiciliar, TipoRegistroHistoricoClinico } from 'graphql/types.generated'
import { turnoByStringRecord, turnoRecord } from 'types/enums'
import { formatDate, toDate } from 'util/date/formatDate'

import { convertTag } from '../../folha-rosto/components/ultimos-contatos/converter-ultimosContatos'
import { FolhaRostoUltimosContatosModel } from '../../folha-rosto/components/ultimos-contatos/model'
import { tipoRegistroHistoricoData } from '../../historico/model/model-historico'

export const convertFatoVisitaDomiciliarToContatosModel = (
  visitaDomiciliar: FatoVisitaDomiciliar
): FolhaRostoUltimosContatosModel => {
  const historicoDataRecord = tipoRegistroHistoricoData[TipoRegistroHistoricoClinico.VISITA_DOMICILIAR]
  const turno = turnoByStringRecord[visitaDomiciliar.turno.descricao.toLowerCase()]
  return {
    id: visitaDomiciliar.nuUuidFicha,
    tipo: TipoRegistroHistoricoClinico.VISITA_DOMICILIAR,
    title: historicoDataRecord.descricao,
    barColor: historicoDataRecord.barColor,
    icon: historicoDataRecord.icon,
    color: historicoDataRecord.iconColor,
    dataOrTurno: `${formatDate(visitaDomiciliar.dataVisita)} - ${turnoRecord[turno]}`,
    headerTags: convertTag(historicoDataRecord.tags, visitaDomiciliar.dimensaoDesfechoVisita.id),
    historicoAtendimento: {
      isAtendRecente: false,
      codigoUnicoRegistro: visitaDomiciliar.nuUuidFicha,
      dataAtendimento: toDate(visitaDomiciliar.dataVisita).getTime(),
      tipoApresentacao: TipoRegistroHistoricoClinico.VISITA_DOMICILIAR,
      cpfCnsCidadao: visitaDomiciliar.cpfCidadao ?? visitaDomiciliar.cnsCidadao,
      origemAtendimento: visitaDomiciliar.origem,
    },
    hasObservacao: false,
    isCuidadoCompartilhado: false,
  }
}
